import { css } from '@microsoft/fast-element';
export const foundationStepperStyles = css `
  :host {
    display: flex;
    height: 100%;
    width: 100%;
  }

  :host([orientation='horizontal']) {
    flex-direction: column;
  }

  .stepper-tab {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-width: 280px;
    border-radius: 0;
  }

  .action-buttons-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .stepper-panel-container {
    height: 100%;
    padding: 15px;
  }

  .stepper-tab-menu {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 30px;
  }

  .stepper-tab-progress {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    flex: 1;
  }

  .stepper-tab-progress .progress-ring {
    --design-unit: 10;

    margin: 0;
  }

  .stepper-tab-panel {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 370px;
    border-radius: 0;
  }

  label {
    padding: 0 10px;
    color: rgb(135 155 166);
    display: block;
    cursor: pointer;
    text-align: center;
    font-size: var(--type-ramp-base-font-size);
    line-height: var(--type-ramp-base-line-height);
    font-style: normal;
    margin: calc(var(--design-unit) * 2px) 0;
  }

  :host([orientation='horizontal']) .stepper-tab-menu {
    height: 100%;
    flex-direction: row;
    margin-bottom: 0;
    align-items: center;
    justify-content: center;
  }

  :host([orientation='horizontal']) .stepper-tab {
    max-width: 100%;
    max-height: 70px;
  }
`;
